import React, { useEffect, useState } from "react";
import { createStackNavigator } from "@react-navigation/stack";
import GetStartedScreen from "../getStartedScreen/GetStartedScreen";
// import SignUpScreen from '../signUpScreen/SignUpScreen';
import LoginScreen from "../loginScreen/LoginScreen";
import UsernameDisplaynameScreen from "../signInScreen/UsernameDisplaynameScreen";
import SignUpScreen from "../signInScreen/SignUpScreen";
import MyCityState from "../signInScreen/MyCityState";
import UserBioSettingUp from "../signInScreen/UserBioSettingUp";
import OnboardingScreen from "./OnboardingScreen";
import AsyncStorage from "@react-native-async-storage/async-storage";
import GoogleSign from "../signInScreen/GoogleSign";
import PhoneNumberScreen from "../signInScreen/PhoneNumberScreen";
import AnonymousOnboardingOTP from "../anonymousOnboarding/AnonymousOnboardingOTP";
import PersonalDetailsScreen from "../signInScreen/PersonalDetailsScreen";
import IdentityScreen from "../signInScreen/IdentityScreen";

const Stack = createStackNavigator();

const GetStartedNavigation = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
      // 🌟 Immediately loads your screen featuring Google, Apple & WhatsApp logic
      initialRouteName="sign_in_start"
    >
      {/* Crossroads Landing Page */}
      <Stack.Screen name="sign_in_start" component={GoogleSign} />

      {/* Other screens kept sequentially registered in your routing map */}
      <Stack.Screen name="phone_number" component={PhoneNumberScreen} />
      <Stack.Screen name="sign_up" component={GoogleSign} />
      <Stack.Screen name="sign_ups" component={SignUpScreen} />
      <Stack.Screen name="username_displayname" component={UsernameDisplaynameScreen} />
      <Stack.Screen name="my_city_state" component={MyCityState} />
      <Stack.Screen name="setProfileBio" component={UserBioSettingUp} />
      <Stack.Screen name="log_in" component={LoginScreen} />
      <Stack.Screen name="otp_page" component={AnonymousOnboardingOTP} />
      <Stack.Screen name="personalDetails" component={PersonalDetailsScreen} />
      <Stack.Screen name="identityScreen" component={IdentityScreen} />
    </Stack.Navigator>
  );
};

export default GetStartedNavigation;
